import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserTypesRelationshipService } from 'src/app/services/user-types-relationship.service';
import { ProviderPhraseAssociationService } from '../phrases/phrases-association/phrases-association.service';

@Component({
  selector: 'app-business-officer-association',
  templateUrl: './business-officer-association.component.html',
  styleUrls: ['./business-officer-association.component.css']
})
export class BusinessOfficerAssociationComponent implements OnInit {


  displayedColumns: string[] = ['providers', 'business_officer'];
  dataSource: any = new MatTableDataSource([]);
  public providers: any = [];
  public relationData: any;
  businessOfficeDropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'full_name',
    selectAllText: 'Select All',
    enableCheckAll: true,
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 'All',
    allowSearchFilter: true
  };
  company_id: any;
  providerPhrase: Boolean = true;

  selectedItems = [];
  dropdownList = [];
  businessOfficers: any = [];
  selectedProvider: any;

  constructor(
    public services: UserTypesRelationshipService,
    private route: ActivatedRoute,
    private phraseAssociateService: ProviderPhraseAssociationService,
    private toastr: ToastrService
  ) { }



  async ngOnInit() {
    if (window.location.pathname.includes('company')) {
      this.company_id = this.route.parent.snapshot.params.id
    }
    else {
      this.company_id = '';
    }
    await this.loadDataForProvider();
  }

  async loadDataForProvider() {
    let res = await this.phraseAssociateService.getAllSameCompanyProviders(this.company_id).subscribe((data: any) => {
      if (data.status == 200) {
        this.loadDataForBOs();
        this.providers = data;
        this.providers = this.providers.data;
        this.dataSource = this.providers;
        this.dataSource = new MatTableDataSource(this.providers);
        // console.log('providers',this.dataSource);
      }
    });
  }

  async loadDataForBOs() {
    this.services.getBOList('true', this.company_id).subscribe((res: any) => {
      // console.log("response",res.data);
      if (res.status == 200) {
        this.loadRelations();
        this.businessOfficers = res.data;
        this.businessOfficers.forEach(element => {
          element['full_name'] = element['first_name'] + ' ' + element['last_name'];
        });
        // console.log('medical assistants', this.businessOfficers);
        this.providers.forEach(provider => {
          provider.businessOfficers = this.businessOfficers;
        });
      }
    });
  }

  async loadRelations() {
    this.services.getBOAssociations(this.company_id).subscribe((res: any) => {
      if (res.status == 200) {
        let associatedBOs = res.data;
        console.log("this.providers", this.providers);
        console.log("this.associatedBOs", associatedBOs);
        this.providers.forEach(provider => {
          associatedBOs.forEach(bo => {
            if (bo.provider_id == provider._id) {
              if (bo?.assoc_bo_ids) {
                bo.assoc_bo_ids = bo.assoc_bo_ids.map(data => {
                  data.full_name = data.first_name + ' ' + data.last_name
                  return data;
                }
                );

                provider.assoc_bo_ids = bo.assoc_bo_ids;
              }
              else {
                provider.assoc_bo_ids = [];
              }
            }
          });
        });
      }
    });
  }

  onBOSelectAll(event, provider) {
    const details = {
      providerID: provider._id,
      BO_ID: this.businessOfficers.map(a =>  a._id ),
      // company_id: provider.company_id
      company_id: this.company_id
    }
    this.createRelationProvider2BO(details);
  }

  onBODeSelectAll(event, provider) {
    const details = {
      providerID: provider._id,
      BO_ID: [],
      // company_id: provider.company_id
      company_id: this.company_id
    }
    this.createRelationProvider2BO(details);
  }

  onBOSelect(businessOffice, selectedProvider) {
    const details = {
      providerID: selectedProvider._id,
      BO_ID: [businessOffice._id],
      // company_id: selectedProvider.company_id
      company_id: this.company_id
    }
    this.createRelationProvider2BO(details);
  }
  createRelationProvider2BO(details) {
    this.services.createRelationProvider2BO(details).subscribe((response: any) => {
      if (response.status == 200) {
        // console.log('success');
        this.toastr.success("Relationship updated");
      }
    })
  }

  onBODeSelect(businessOffice, selectedProvider) {
    const details = {
      ProviderID: selectedProvider._id,
      BO_ID: businessOffice._id,
      // company_id: selectedProvider.company_id
      company_id: this.company_id
    }
    this.deleteRelationProvider2BO(details);
  }

  deleteRelationProvider2BO(details) {
    this.services.deleteRelationProvider2BO(details).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success("Relationship updated");
      }
    })
  }
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
